import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'
import { HawalaBranchesListWrapper } from './hawala-branches-list/Hawala-BranchesList'

const hawala_branchesBreadcrumbs: Array<PageLink> = [
  {
    title: 'HawalaBranch Management',
    path: '/admin/pages/hawala-branches',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/hawala-branches/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const HawalaBranchPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='hawala_branches'
          index
          element={
            <>
              <PageTitle breadcrumbs={hawala_branchesBreadcrumbs}>HawalaBranches list</PageTitle>
              <HawalaBranchesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/hawala-branches/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/hawala-branches' />} />
    </Routes>
  )
}

export default HawalaBranchPage
